import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import ContactPage from '../components/Media/ContactPage';
import ErrorBoundary from '../components/ErrorBoundary';
import SuccessionThemeProvider from '../components/Succession/SuccessionThemeProvider';
import getMessages from '../lib/i18n/getMessages';

/**
 * MediaContactContainer
 *
 * Wraps the modernized /media/contact page. Content is resolved server-side by
 * MediaContactContent (it depends on Company.current, affiliate_name and the
 * tenant's catastrophic planning word), so there is no data fetching here — the
 * container exists to supply the theme and i18n providers the Succession tokens
 * rely on. /media/contact renders under the findbob_front_end layout, outside
 * Succession, so without SuccessionThemeProvider the token CSS variables would
 * be undefined and every colour would fall back to the browser default.
 */
const MediaContactContainer = (props, railsContext) => {
  const { content, current_user: currentUser, company } = props;
  const {
    i18nLocale, company_id: companyId, company_name: companyName, company_host: companyHost,
  } = railsContext || {};

  window.locale = i18nLocale || window.locale || 'en';
  const { locale } = window;

  const companyData = company || {
    id: companyId,
    name: companyName,
    host: companyHost,
  };

  return (
    <IntlProvider locale={locale} messages={getMessages(locale)}>
      <SuccessionThemeProvider company={companyData} user={currentUser}>
        <ErrorBoundary>
          <ContactPage content={content} />
        </ErrorBoundary>
      </SuccessionThemeProvider>
    </IntlProvider>
  );
};

MediaContactContainer.propTypes = {
  content: PropTypes.object,
  current_user: PropTypes.object,
  company: PropTypes.object,
};

MediaContactContainer.defaultProps = {
  content: null,
  current_user: null,
  company: null,
};

export default MediaContactContainer;
